import React, { Fragment } from 'react'
import { Breadcrumbs } from '../../../../AbstractElements';
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import RevenueShareReportView from './RevenueShareReportView'

const RevenueShareReport = () => {
    return (
        <Fragment>
            <Breadcrumbs parent="Report" title="Revenue share Report" mainTitle="Revenue share Report" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <RevenueShareReportView />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default RevenueShareReport